export const BACKFILL_VALUES = {
  ALLOW: 'allowBackfill',
  DONT_ALLOW: 'dontAllowBackfill',
};

export const APPROVAL_VALUES = {
  REQUIRE: 'required',
  DONT_REQUIRE: 'dontRequire',
};

export const SHIFT_TIME_ALERT_TYPES = {
  OT: 'ot',
  MAX: 'max',
};

export const TIME_FIELDS_ERRORS = {
  shiftLength: 'error.jobCreate.shiftLength',
};

export const MAX_JOBS_TOTAL = 31;

export const FAQ_LIST = [
  {
    header: 'job.create.faq.changeJobEndDate.header',
    bodyElements: ['job.create.faq.changeJobEndDate.body1'],
  },
  {
    header: 'job.create.faq.howManyWorkersAfterJobPost.header',
    bodyElements: [
      'job.create.faq.howManyWorkersAfterJobPost.body1',
      'job.create.faq.howManyWorkersAfterJobPost.body2',
    ],
  },
  {
    header: 'job.create.faq.whatIsWaeAutofill.header',
    bodyElements: ['job.create.faq.whatIsWaeAutofill.body1'],
  },
  {
    header: 'job.create.faq.canIRemoveWorkersFromRoster.header',
    bodyElements: [
      'job.create.faq.canIRemoveWorkersFromRoster.body1',
      'job.create.faq.canIRemoveWorkersFromRoster.body2',
    ],
  },
  {
    header: 'job.create.faq.sameWorkersOnEveryShift.header',
    bodyElements: ['job.create.faq.sameWorkersOnEveryShift.body1'],
  },
  {
    header: 'job.create.faq.alreadyAnExistingShift.header',
    bodyElements: ['job.create.faq.alreadyAnExistingShift.body'],
  },
];
